import React from 'react';
import ProgressBar from './ProgressBar';
import ThumbProgressBar from './ThumbProgressBar';
import Resizer from "react-image-file-resizer";

const {useState} = React;


export const Upload = () => {
    const [file, setFile] = useState(null);
    const [thumb, setThumb] = useState(null);
    const [category, setCategory] = useState("Monochrome");
    const [error, setError] = useState(null);
    const [imgUrl, setImgUrl] = useState(null);

    const types = ['image/png', 'image/jpeg', 'image/jpg'];

    const changeCat = (e) =>{
        setCategory(e.target.value);
    }

    const changeHandler = (e) => {
        let selected = e.target.files[0];

        if(selected && types.includes(selected.type) && category) {
            setFile(selected);
            Resizer.imageFileResizer(
                selected, // the file from input
                480, // width
                480, // height
                "jpeg", // compress format WEBP, JPEG, PNG
                100, // quality
                0, // rotation
                (uri) => {
                    setThumb(uri);
                },
                "file" // blob or base64 default base64
            );
        }
        else {
            setFile(null);
            setThumb(null);
            setError("Please select an image (png or jpg or jpeg) or a Category");
        }
    }


    return (
        <div id="upload" style={{"display": "flex", "justifyContent": "center", "alignItems": "center", "padding": "20px"}}>
            <form>
                <label for="genre">Image Category: </label>
                <select name="genre" onChange={changeCat} id="genrelist">
                    <option value="Monochrome">Monochrome</option>
                    <option value="Nature">Nature</option>
                    <option value="Landscape">Landscape</option>
                    <option value="People">People</option>
                    <option value="Street">Street</option>
                    <option value="Silhouette">Silhouette</option>
                    <option value="Architecture">Architecture</option>
                </select> 
                <br />
                <br />
                <label for="image">Upload an Image: </label>
                <input name="image" onChange={changeHandler} type="file"/>
                <div className="output">
                    {error && <div className="error">{error}</div>}
                    {file && <div className="file">{file.name}</div>}
                    <br />
                    {
                        (file && category) && 
                        <div>
                            <ProgressBar file={file} setFile={setFile} genre={category} setImgUrl={setImgUrl} />
                        </div>
                    }
                    {
                        (thumb && category && imgUrl) &&
                        <div>
                            <ThumbProgressBar file={thumb} setThumb={setThumb} genre={category} imgUrl={imgUrl} setImgUrl={setImgUrl} />
                        </div>
                    }
                </div>
            </form>
        </div>
    );
}